import CirculoError from "../../../../assets/images/generico/CirculoError";
import CirculoTildeOk from "../../../../assets/images/generico/CirculoTildeOk";
import { ContainerResumenLista, Item } from "./localStyle";
import { getLocalStorage } from "global/utils/safeJsonParse";

const ResumenLista = ({ lista }) => {
  const idTerminal = getLocalStorage("idTerminal");

  return (
    <ContainerResumenLista>
      {lista.map((item, index) => {
        return (
          <Item $isTerminal={idTerminal} key={index}>
            {item.estado ? <CirculoTildeOk /> : <CirculoError />}
            <span className={`${idTerminal ? "rb24t" : "rb18m"}`}>
              {item.nombre}
            </span>
          </Item>
        );
      })}
    </ContainerResumenLista>
  );
};

export default ResumenLista;
